export const events = {
  eventsCardDurationText: '기간',
  eventsSearchInputText: '검색',
  eventsRegisteredToEventAlertTitle: '성공적으로 등록되었습니다',
  eventsUnregisteredToEventAlertTitle: '성공적으로 등록 해제되었습니다',
  eventsExternalRegistrationPopupTitle: '등록',
  eventsExternalRegistrationPopupContent: '성공적으로 등록되었습니까?',
  eventsExternalRegistrationNoButtonTitle: '아니오',
  eventsExternalRegistrationYesButtonTitle: '예',
  eventsCurtainCopyOptionTitle: '링크 복사',
  eventsCurtainFlagOptionTitle: '콘텐츠 신고',
  eventsLinkCopiedAlertText: '링크가 복사되었습니다!',
  eventsCurtainAddToCalendOptionTitle: '캘린더에 추가',
  eventdetailsAgendaButtonTitle: '일정',
  eventdetailsOnMapButtonTitle: '지도에서 보기',
  eventdetailsOnlineLocationTitle: '온라인',
  eventdetailAmountsRegisteredText: '참가자',
  eventdetailsSeeAllButtonTitle: '모두 보기',
  eventdetailsRegisteredButtonTitle: '등록된 사람들',
  eventdetailsRegisterButtonTitle: '등록',
  eventdetailsRegisteredAlertText: '성공적으로 등록되었습니다',
  eventdetailsUnregisteredAlertText: '성공적으로 등록 해제되었습니다',
  eventdetailsAgendaTitle: '일정',
  eventdetailsSeeAllRegisteredCurtainTitle: '등록된 사용자',
  eventdetailsSpeakersCurtainTitle: '스피커',
  eventdetailsSpeakersSectionTitle: '스피커',
  eventdetailsSpeakersSectionSeeAllButtonTitle: '모두 보기',
  eventdetailsCustomSectionSeeAllButtonTitle: '모두 보기',
  eventdetailsCurtainCopyOptionTitle: '링크 복사',
  eventdetailsCurtainFlagOptionTitle: '콘텐츠 신고',
  eventsdetailsLinkCopiedAlertText: '링크가 복사되었습니다!',
  eventdetailsCurtainAddToCalOptionTitle: '캘린더에 추가',
  eventDetailsAddCalendarPopupTitle: '캘린더',
  eventdetailsAddCalendarPopupContent: '캘린더에 추가하시겠습니까?',
  eventdetailsAddCalendarPopupNoButtonTitle: '아니오',
  eventdetailsAddCalendarPopupYesButtonTitle: '예',
  eventdetailsSpeakerCurtainCopyOptionTitle: '링크 복사',
  eventdetailsSpeakerCurtainFlagOptionTitle: '콘텐츠 신고',
  eventsdetailsSpeakersLinkCopiedAlertText: '링크가 복사되었습니다!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: '링크 복사',
  eventdetailsCustomSectionCurtainFlagOptionTitle: '콘텐츠 신고',
  eventsFlag: '신고',
  eventsJoin: '참가',
  eventdetailsCustomSectionLinkCopiedAlertText: '링크가 복사되었습니다!',
  eventContentReported: '콘텐츠가 신고되었습니다',
  eventsError: '문제가 발생했습니다!',
  eventdetailsExternalRegistrationPopupContent: '성공적으로 등록되었습니까?',
  eventdetailsExternalRegistrationNoButtonTitle: '아니오',
  eventdetailsExternalRegistrationYesButtonTitle: '예',
  eventdetailsExternalRegistrationPopupTitle: '등록',
  eventsCardRegisteredButtonTitle: '등록된 사람들',
  eventsCardRegisterButtonTitle: '등록',
  eventsJoinLink: '참가 링크: [url]{link}[/url][br]',
  eventsGuest: '손님',
  eventsNoSessionInDay: '이 날에는 행사가 없습니다.',
  eventsShowUpcomingEvent: '다가오는 이벤트 보기'
}
